import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';

export enum SignOnBonusPrescriberType {
  MEDICAL_DOCTOR = 'medical_doctor',
  DOCTOR_OF_OSTEOPATHY = 'doctor_of_osteopathy',
  NURSE_PRACTITIONER = 'nurse_practitioner',
  PHYSICIAN_ASSISTANT = 'physician_assistant',
}

export enum SignOnBonusReferralSource {
  PROVIDER = 'provider',
  ADMIN = 'admin',
}

export type CreateProviderReferralInput = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  prescriberType: SignOnBonusPrescriberType;
  stateIds: string[];
  referralSource: SignOnBonusReferralSource;
};

export type CreateProviderReferralResponse = {
  error: string;
  error_key: 'email_already_exists';
};

export type ProviderSignOnBonusReferral = {
  id: string;
  providerId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  prescriberType: SignOnBonusPrescriberType;
  stateIds: string[];
  referralSource: SignOnBonusReferralSource;
  createdBy: string;
  createdAt: string;
};

export const createProviderReferral = (providerId: string, body: CreateProviderReferralInput) =>
  restClient.request<CreateProviderReferralResponse>(`/api/v1/providers/${providerId}/referral`, {
    method: 'POST',
    data: snakecaseKeys(body),
  });

export const getProviderReferrals = (providerId: string) =>
  restClient.request <{ data: ProviderSignOnBonusReferral[] }>(`/api/v1/providers/${providerId}/referrals`, {
    method: 'GET',
  });

export const getProviderReferralById = (providerId: string, referralId: string) =>
  restClient.request<{ data: ProviderSignOnBonusReferral }>(`/api/v1/providers/${providerId}/referrals/${referralId}`, {
    method: 'GET',
  });
